<template>
  <label :for="$props.id" class="file-input-wrapper">
    <span class="label">{{ $props.label }}</span>
    <span class="file-input" :class="{'error': fileError || fileSizeError}">
      <input type="file"
             :id="$props.id"
             :name="$props.name"
             :accept="$props.fileTypes.toString()"
             ref="input"
             v-uploader/>
    </span>
    <span class="file-placeholder">{{ fileName }}</span>
    <span class="icon-sc-attachment file-icon"></span>

    <span v-if="fileError" class="error-msg">{{ $props.errorMessage }}</span>
    <span v-if="fileSizeError" class="error-msg">{{ $props.sizeErrorMessage }}</span>
  </label>
</template>

<script>
export default {
  name: 'base-file-input',
  data () {
    return {
      file: null,
      error: false,
      sizeError: false
    }
  },
  props: {
    id: String,
    name: String,
    placeholder: String,
    label: String,
    fileTypes: {
      type: Array,
      default: () => []
    },
    errorMessage: String,
    sizeErrorMessage: String
  },
  directives: {
    uploader: {
      bind (el, binding, vnode) {
        el.addEventListener('change', e => {
          const fileExt = e.target.files.length ? e.target.files[0].name.match(/\.([^]+)$/)[1] : ''
          const fileSize = e.target.files.length ? e.target.files[0].size : 0
          const maxSize = 5000000 // 5MB in bytes
          if (fileExt && !vnode.context.fileTypes.includes(`.${fileExt}`)) {
            vnode.context.file = null
            vnode.context.error = true
            vnode.context.sizeError = false
          } else if (fileSize > maxSize) {
            vnode.context.file = null
            vnode.context.error = false
            vnode.context.sizeError = true
          } else {
            // file ne može da se emituje kroz v-model, tako da odabrani fajl setujemo u lokalnoj promenljivoj file
            // fajlu se kasnije može pristupiti kroz ref kad zatreba
            vnode.context.file = e.target.files[0]
            vnode.context.error = false
            vnode.context.sizeError = false
          }
        })
      }
    }
  },
  computed: {
    fileName () {
      if (this.file) {
        return this.file.name || ''
      }
      return this.$props.placeholder
    },
    fileError () {
      return this.error && this.$props.errorMessage
    },
    fileSizeError () {
      return this.sizeError && this.$props.sizeErrorMessage
    }
  }
}
</script>
<style scoped lang="scss">
.file-input-wrapper {
  position: relative;
  display: block;
  cursor: pointer;

  .label {
    color: $dark-grey;
    font-size: 1.2rem;
    margin-bottom: 0.8rem;
    display: inline-block;
  }

  .file-placeholder {
    position: absolute;
    bottom: 2.9rem;
    left: 1.6rem;
    top: auto;
    color: $dark-grey;
    width: calc(100% - 6rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .file-input {
    display: block;
    width: 100%;
    min-height: 48px;
    background-color: $white;
    border: 1px solid transparent;
    border-radius: 5px;

    &.error {
      border-color: $error;
    }

    input[type=file] {
      position: absolute;
      z-index: -1;
      display: none;
      width: 0;
      height: 0;
    }
  }

  .file-icon {
    position: absolute;
    bottom: 2.9rem;
    right: 1.6rem;
    font-size: 2.4rem;
    color: $dark-grey;
    display: inline-block;
    transition: color 150ms;
  }

  &:hover .file-icon {
    color: $text;
  }

  .error-msg {
    display: block;
    position: absolute;
    top: 74px;
    left: 0;
    text-align: left;
    font-size: 1.2rem;
    line-height: 1;
    color: $error;
  }
}
</style>
